import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';


  export const getUserProfile = async () => {
    try {
      const userInfo = fetchUser();  
      const {data}  = await Axios.get(
        `/usuario/profile?empresa=${userInfo.empresa}&idUsuario=${userInfo.usuario}&rol=${userInfo.rol}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateProfileUsuario = async (usuario) => {
    try {
        const userInfo = fetchUser();
        const {data}  = await Axios.patch(
          `/usuario/profile/${usuario._id}`, usuario
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

export const getUsuariosSucursal = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/usuario/emp?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearUsuarioSucursal = async (usuario) => {
    try {
        const userInfo = fetchUser();
        usuario.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/usuario', usuario
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateUsuarioSucursal = async (usuario) => {
    try {
        const userInfo = fetchUser();
        usuario.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/usuario/${usuario._id}`, usuario
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updatePasswordUsuario = async (usuario) => {
    try {
        const {data}  = await Axios.patch(
          '/usuario/cambiopassword', usuario
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteUsuarioSucursal = (Id) => Axios.delete(`/usuario/${Id}`);
